import React from 'react';
import styled from 'styled-components';

import SegmentSliderHotelCardLoader from '../SegmentSliderHotelCardLoader/SegmentSliderHotelCardLoader';
import SegmentTypeInfoGoStays from '../SegmentTypeGoStays/SegmentTypeGoStays';

const SliderMainContentWrapper = styled.div(
  props => `
    background-color:${props.theme.colors.goWhite.base};
    flex-direction: row;
    align-items: center;
    margin: ${props.theme.spacing.base} 0 ${props.theme.spacing.base} 0;
    border-radius: ${props.theme.misc.borderRadius.large};
    display: flex;
    `,
);

const SegmentSliderLoader = () => (
  <SliderMainContentWrapper>
    {/* <SegmentTypeInfoGoStays /> */}
    <SegmentSliderHotelCardLoader />
  </SliderMainContentWrapper>
);

export default SegmentSliderLoader;
